import ko from 'knockout'
import { IResultedImageViewModelParams, ResultedImageViewModel } from './ResultedImageViewModel'
import template from './resulted.image.tpl.html'

if (!ko.components.isRegistered('resulted-image')) {
  ko.components.register('resulted-image', {
    viewModel: {
      createViewModel: (params: IResultedImageViewModelParams) => {
        const viewModel = new ResultedImageViewModel(params)
        return viewModel
      },
    },
    template,
  })
}
